export default function getSVGElementBounds(element, parentContainer) {
  if (!element) return;

  const { x, y, width, height } = element.getBoundingClientRect();

  return {
    top: y - parentContainer.offsetTop,
    left: x - parentContainer.offsetLeft,
    width,
    height
  };
}
